module.exports = __webpack_public_path__ + "media/src/images/user/default_avatars/default_avatar_10-4b0074154d3280e73c7a6c0ee44db0ad.png";